import { render, staticRenderFns } from "./FarmRecords.vue?vue&type=template&id=b5655894&scoped=true"
import script from "./FarmRecords.vue?vue&type=script&lang=js"
export * from "./FarmRecords.vue?vue&type=script&lang=js"
import style0 from "./FarmRecords.vue?vue&type=style&index=0&id=b5655894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5655894",
  null
  
)

export default component.exports